import { Grid } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import BaseButton from 'src/common/components/base-button';
import { AppState } from 'src/common/redux/configure-store';
import { trainingModeStyles } from 'src/common/training-mode/training-mode-styles';
import { codeContainerStyles } from '../../common/components/code-container/components/code-container-styles';
import { useTranslation } from 'react-i18next';
import { PosFilterAction } from 'src/search-transactions/components/saved-transaction/enumerations/pos-filter-action';
import { transactionSearchModalStyles } from 'src/transaction-search/transaction-based-return-styles';
import { CssTextField } from 'src/price-override/components/price-override-input/price-override-input-styles';

const OwnBagSelectionWindow = (props: IOwnBagSelectionProps): JSX.Element => {
  const classes = codeContainerStyles();
  const trainingModeClasses = trainingModeStyles();
  const { t } = useTranslation();
  const leftHanded = useSelector(
    (state: AppState): boolean => state?.cashierPreferences?.leftHanded,
  );
  const trainingMode = useSelector((state: AppState): boolean => state?.posMode?.trainingMode);

  return (
    <Grid
      item
      className={`fullHeight flexFull ${classes.outerMostContainer}`}
      data-testid='own-bag'
    >
      <Grid
        item
        className={`${
          trainingMode ? trainingModeClasses.trainingModeBackground : classes.background
        } fullWidth fullHeight`}
      >
        <Grid
          container
          direction='column'
          className={`fullHeight ${classes.outerFlexDesign}`}
          data-testid='own-bag-scanning-container'
        >
          <Grid
            item
            container
            className={classes.flexDesign}
            direction={leftHanded ? 'row-reverse' : 'row'}
            data-testid='own-bag-body-container'
          >
            <Grid item container className={classes.containerAlignment}>
              <InputField
                value={props.inputValue}
                onChange={props.onChange}
                action={PosFilterAction.FilterPos}
              />
            </Grid>
            <Grid item container justifyContent='center' className={classes.selfAlign}>
              <BaseButton
                buttonType='white'
                onClick={props.onCancel}
                data-testid='own-bag-cancel-button'
              >
                {t('Cancel')}
              </BaseButton>
              <BaseButton
                data-testid='own-bag-approve-button'
                className={classes.addButton}
                onClick={props.onSubmit}
                disabled={props.inputValue === ''}
              >
                {t('Approve')}
              </BaseButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const InputField: React.FC<IInputFieldProps> = (props: IInputFieldProps): JSX.Element => {
  const classes = transactionSearchModalStyles();
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid item data-testid='own-bag-input'>
        <CssTextField
          variant='outlined'
          label={t('OwnBagLabelText')}
          autoComplete='off'
          className={`${classes.textFieldInput}`}
          id={props.action}
          name={props.action}
          onFocus={props.onChange}
          inputProps={{
            'data-testid': `own-bag-keypad-input`,
            'data-keyboard-owner': `own-bag-keypad-focus`,
          }}
          value={props.value}
          autoFocus={true}
          onChange={props.onChange}
          onKeyDown={props.onChange}
        />
      </Grid>
    </Grid>
  );
};

interface IInputFieldProps {
  onChange: (e: any) => void;
  value: string;
  action: PosFilterAction;
}

export interface IOwnBagSelectionProps {
  onCancel: () => void;
  onSubmit: () => void;
  onChange: (e: any) => void;
  inputValue: string;
}

export default OwnBagSelectionWindow;
